export default __webpack_public_path__ + "static/media/message-logs.ee961d78.svg";